import React, { useRef, useState, RefObject } from 'react'
import { AccordionV2, Container } from '@cleartrip/ct-design-components'
import { isEmpty } from '@/utils/general/browserHelper'
import FareRules from '@/components/srp/FlightDetails/FareRules'
import NewFareRules from '@/components/srp/FlightDetails/NewFareRules'
import FlightItinerary from '@/components/srp/FlightDetails/FlightItinerary'
import FlightInfo from '@/components/srp/FlightDetails/FlightInfo'
import { getSrpSearchData } from '@/redux/slices/srpSlice'
import { useAppSelector } from '@/redux/store/hooks'
import { Card, Benefit, FareType, searchFlightsType } from '@/types/srp'
interface FlightDetailsBodyProps {
    selectedTab: number
    cards: Card[] | []
    flightBenefitsData?: any
    baggageAllowancesInfo?: {
        onWardsBaggageData?: {
            benefitList?: any[]
            benefitSummary?: any[]
        }
        returnBaggageData?: {
            benefitList?: any[]
            benefitSummary?: any[]
        }
    }
    isIntl?: boolean
    isTripDetails?: boolean
    isIntlSpecialRT?: boolean
    searchQuery?: any
}

const FlightDetailsBody = ({ selectedTab = 0, cards = [], flightBenefitsData = {}, baggageAllowancesInfo = {}, isIntl = false , isTripDetails = false, isIntlSpecialRT = false, searchQuery = {}}: FlightDetailsBodyProps) => {
    const [selectedAccordian, setSelectedAccordian] = useState<Record<number, string>>({
        0: 'open',
        1: 'open'
    })
    const accordianRef = useRef<HTMLDivElement[]>([])
    const { searchData } = useAppSelector(getSrpSearchData)
    const { metaData = {}, subTravelOptions = {}, flights: flightsData = {}, baggageAllowances = {} } = searchData || {}
    const isRoundTrip = cards.length > 1

    const onAccordianClick = (index: number) => {
        if (!isRoundTrip) return
        if (selectedAccordian?.[index] === 'open') {
            setSelectedAccordian({
                ...selectedAccordian,
                [index]: 'close'
            })
        } else {
            setSelectedAccordian({
                ...selectedAccordian,
                [index]: 'open'
            })
            if (index > 0 && accordianRef?.current?.[index]) {
                setTimeout(() => {
                    accordianRef.current?.[index]?.scrollIntoView({ behavior: 'smooth' })
                }, 100)
            }
        }
    }

    const getBaggageData = () => {
        let baggageDataList: Partial<Benefit[]> = []
        cards.map(card => {
            const { subTravelOptionIds = [] } = card || {}
            let { cheapestFareId = '', fareList = [] } = subTravelOptions?.[subTravelOptionIds?.[0]]
            let cheapestFare = fareList.find((fare: Partial<FareType> = {}) => {
                return fare?.fareId === cheapestFareId
            })
            let { benefits: { baggageAllowanceId = '' } = {} } = cheapestFare || {}
            let baggageData = baggageAllowances?.[baggageAllowanceId]
            baggageDataList.push(baggageData || {})
        })
        return baggageDataList
    }

    let baggageData = getBaggageData() || []

    if (isEmpty(cards)) return <></>
    return cards.map((item, journeyIndex, arr) => {
        const flightsKeyList: any = []
        const segmentsList: any = []
        const { summary = {}, subTravelOptionIds = [] } = cards[journeyIndex] || {}
        subTravelOptionIds.map((subTravelOptionId: string | number) => {
            const flightIds = subTravelOptions[subTravelOptionId]?.sequenceToFlightIdMap || {}
            Object.keys(flightIds).map(flightId => {
                flightsKeyList.push(flightIds[flightId])
            })
        })
        flightsKeyList.map((key: string | number) => {
            segmentsList.push(flightsData[key])
        })
        return (
            <>
                <Container className="p-sticky b-0" onClick={() => onAccordianClick(journeyIndex)}>
                    <FlightInfo
                        isOpen={selectedAccordian?.[journeyIndex] === 'open'}
                        metaData={metaData}
                        summary={summary}
                        isRoundTrip={isRoundTrip}
                    />
                </Container>
                <AccordionV2 label={<></>} expanded={!isRoundTrip || selectedAccordian?.[journeyIndex] === 'open'}>
                    <Container className="mt-3" ref={(el: any) => (accordianRef.current[journeyIndex] = el)}>
                        {selectedTab === 0 ? (
                            segmentsList.map(
                                (segment: searchFlightsType, index: number, segmentArray: searchFlightsType[]) => {
                                    return selectedTab === 0 ? (
                                        <FlightItinerary
                                            segmentsList={segmentsList}
                                            metaData={metaData}
                                            segmentArray={segmentArray}
                                            index={index}
                                            segment={segment}
                                            baggageData={baggageData?.[journeyIndex]}
                                            baggageAllowancesInfo={journeyIndex === 0 ? baggageAllowancesInfo?.onWardsBaggageData : baggageAllowancesInfo?.returnBaggageData}
                                            isIntl={isIntl}
                                            searchQuery={searchQuery}
                                            journeyIndex={journeyIndex}
                                            layoverInfo={cards[journeyIndex]?.layover}
                                        />
                                    ) : (
                                        <></>
                                    )
                                }
                            )
                        ) : (
                            <>
                              {isIntl && (isTripDetails || !isRoundTrip) &&  <NewFareRules
                                    penaltiesData={journeyIndex === 0 ? flightBenefitsData?.onWardsData : flightBenefitsData?.returnData}
                                    isLoading={false}
                                    isIntlSpecialRT={isIntlSpecialRT}
                                />}
                            </>
                        )}
                    </Container>
                </AccordionV2>
            </>
        )
    })
}

export default FlightDetailsBody
